var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15094_57901)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15094_57901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4423 5.04178V7.89825C21.1479 8.29734 23.3093 10.2582 23.8637 12.8167C24.4182 15.3753 23.2491 17.9933 20.9313 19.3839C18.6135 20.7744 15.6344 20.6448 13.4587 19.0589L11.0259 21.3805C11.089 21.5689 11.1224 21.7651 11.1253 21.9628C11.1253 22.7867 10.6052 23.5296 9.8075 23.8449C9.00981 24.1602 8.09164 23.9859 7.48112 23.4033C6.8706 22.8207 6.68796 21.9444 7.01838 21.1832C7.34879 20.422 8.12718 19.9256 8.99058 19.9256C9.19773 19.9285 9.40331 19.9605 9.60072 20.0204L12.0599 17.6736C10.5094 15.5687 10.4694 12.7719 11.959 10.6273L3.87817 4.62398C3.48829 4.84075 3.04547 4.95573 2.59424 4.95733C1.15977 4.95569 -0.0017114 3.84463 1.89301e-06 2.4757C0.00171898 1.10678 1.16598 -0.00163255 2.60045 1.80507e-06C4.03493 0.00163978 5.19641 1.1127 5.1947 2.48163C5.19135 2.69051 5.16005 2.89813 5.10155 3.09944L13.3205 9.20203C14.2171 8.51398 15.2883 8.06421 16.4256 7.89825V5.04178C15.6181 4.68189 15.1006 3.90989 15.0966 3.05944V2.99277C15.1 1.78066 16.1288 0.798859 17.399 0.795603H17.4688C18.739 0.798859 19.7678 1.78066 19.7712 2.99277V3.05944C19.7673 3.90989 19.2497 4.68189 18.4423 5.04178ZM14.0684 14.0822C14.0684 15.8561 15.5753 17.2942 17.4342 17.2942C19.2932 17.2942 20.8001 15.8561 20.8001 14.0822C20.8001 12.3082 19.2932 10.8701 17.4342 10.8701C15.5753 10.8701 14.0684 12.3082 14.0684 14.0822Z",
    fill: "#FF5C35"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15094_57901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15094_57901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.ef5e2d6227d18e06b30e5a64da5e2817.svg";
export { ForwardRef as ReactComponent };